import moment from 'moment';
import type { Moment } from 'moment/moment';
import { DEFAULT_INPUT_DATE_FORMAT } from '../config/constants';

export const getMomentFromStringOrElseNull = (date?: string) => {
    return date ? moment(date) : null;
};

export const convertToUnixTimestampIfValidDateString = <T>(a: T, b: T) => {
    if (isDate(a, b)) {
        // @ts-expect-error Problems with generic types
        const propA = moment(a, DEFAULT_INPUT_DATE_FORMAT).unix();
        // @ts-expect-error Problems with generic types
        const propB = moment(b, DEFAULT_INPUT_DATE_FORMAT).unix();

        return [propA, propB];
    } else {
        return [a, b];
    }
};

// @ts-expect-error Problems with generic types
const isDate = <T>(a: T, b: T) => moment(a, DEFAULT_INPUT_DATE_FORMAT, true).isValid() && moment(b, DEFAULT_INPUT_DATE_FORMAT, true).isValid();

export const calculateAge = (birthDate: moment.Moment, year: moment.Moment): number => year.year() - birthDate.year();

// Formats a date string with the given moment format, or returns '' when the date is missing/invalid.
export const getDateString = (date?: string | null, dateFormat = DEFAULT_INPUT_DATE_FORMAT): string =>
    date && moment(date).isValid() ? moment(date).format(dateFormat) : '';

export const getDateFromIsoDateString = (isoDate?: string) => moment(isoDate).format('YYYY-MM-DD');
export const getIsoDateFromDateString = (date?: string) => moment.utc(date, 'YYYY-MM-DD', true).toISOString();

export type DateRange = {
    from: Moment | null;
    to: Moment | null;
    id?: number;
};

const isDateRangeOverlapping = (rangeItem1: DateRange, rangeItem2: DateRange) =>
    moment.max(moment(rangeItem1.from), moment(rangeItem2.from)) < moment.min(moment(rangeItem1.to), moment(rangeItem2.to));

export const isValidSurplusDateRange = (referenceDateRanges: DateRange[], from?: string, to?: string, rangeId?: number) => {
    if (!from || !to) return true;

    return !referenceDateRanges
        .filter((item) => item.id !== rangeId)
        .some((existingRange) => isDateRangeOverlapping(existingRange, { from: moment(from), to: moment(to), id: rangeId ?? 0 }));
};
